import { AxiosInstance } from "axios";
import { ISettingsStore, defaultStore } from "../../settings/store";

const toResponse = (response: any): ISettingsStore => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${response.errorMessage}`
    );
  }

  const {
    applicationName,
    shortenerEnabled,
    styleAccentColor1,
    styleAccentColor1Text,
    styleAccentColor2,
    styleAccentColor2Text,
    archiveFilters,
    profileVirtualParameterName,
    targetUrlParameterName,
    customContentDataProtection,
    customContentImprint,
    showDataProtectionDe,
    parameterNameUsedInArchiveEntryHeader,
    styleHeaderImageUrl,
    supportEmailAddress,
    version,
  } = response.result;

  return {
    fetching: false,
    shortenerEnabled,
    applicationName,
    theme: {
      primary: styleAccentColor1,
      textPrimary: styleAccentColor1Text,
      secondary: styleAccentColor2,
      textSecondary: styleAccentColor2Text,
    },
    archiveFilters,
    profileParameterName: profileVirtualParameterName,
    targetUrlParameterName,
    customContentDataProtection,
    customContentImprint,
    showDataProtectionDe,
    parameterNameUsedInArchiveEntryHeader,
    styleHeaderImageUrl,
    supportEmailAddress,
    version: {
      ...defaultStore.version,
      ...(version && { backend: version }),
    },
    archiveViewType: localStorage.getItem("archiveViewType") || "list",
    archiveLinksPerPage: localStorage.getItem("archiveLinksPerPage")
      ? Number(localStorage.getItem("archiveLinksPerPage"))
      : 10,
  };
};

export default (api: AxiosInstance, url: string) => async () => {
  const response = await api.get(url);
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/settings/get.ts